var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { Dialog, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../../../store';
import { updateIsActiveWebcam, updateShowVideoShareModal, } from '../../../../store/slices/bottomIconsActivitySlice';
import { getDevices } from '../../../../helpers/utils';
import PreviewWebcam from './previewWebcam';
import { addVideoDevices } from '../../../../store/slices/roomSettingsSlice';
const showVideoShareModalSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.showVideoShareModal);
$RefreshReg$(_react_refresh_temp_1, "showVideoShareModalSelector$createSelector");
const ShareWebcamModal = ({ onSelectedDevice }) => {
    _react_refresh_temp_3();
    const showVideoShareModal = useAppSelector(showVideoShareModalSelector);
    const [isOpen, setIsOpen] = useState(true);
    const [selectedWebcam, setSelectWebcam] = useState('');
    const [devices, setDevices] = useState([]);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    useEffect(() => {
        const getDeviceWebcams = async () => {
            const mics = await getDevices('videoinput');
            const videoDevices = [];
            const options = mics.map((mic) => {
                const device = {
                    id: mic.deviceId,
                    label: mic.label,
                };
                videoDevices.push(device);
                return (_jsx("option", { value: mic.deviceId, children: mic.label }, mic.deviceId));
            });
            setDevices(options);
            setSelectWebcam(mics[0].deviceId);
            if (videoDevices.length) {
                dispatch(addVideoDevices(videoDevices));
            }
        };
        getDeviceWebcams();
    }, [dispatch]);
    useEffect(() => {
        if (showVideoShareModal) {
            setIsOpen(true);
        }
    }, [showVideoShareModal]);
    const shareWebcam = async () => {
        onClose();
        if (!selectedWebcam) {
            return;
        }
        onSelectedDevice(selectedWebcam);
    };
    const onClose = () => {
        setIsOpen(false);
        dispatch(updateShowVideoShareModal(false));
        dispatch(updateIsActiveWebcam(false));
    };
    const render = () => {
        if (!showVideoShareModal) {
            return null;
        }
        return (_jsx(Transition, { show: isOpen, enter: "transition duration-100 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-75 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0", children: _jsx(Dialog, { open: isOpen, onClose: () => false, className: "share-webcam-popup-wrap fixed z-[99999] inset-0 overflow-y-auto", children: _jsxs("div", { className: "flex items-center justify-center min-h-screen", children: [_jsx(Dialog.Overlay, { className: "fixed inset-0 bg-black opacity-30" }), _jsxs("div", { className: "popup-inner bg-white dark:bg-darkPrimary w-full max-w-md rounded-3xl shadow-header relative px-6 py-14", children: [_jsxs("button", { className: "close-btn absolute top-8 right-6 w-[25px] h-[25px] outline-none", type: "button", onClick: () => onClose(), children: [_jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 rotate-45" }), _jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 -rotate-45" })] }), _jsx(Dialog.Title, { className: "mb-6 dark:text-darkText", children: t('footer.modal.select-webcam') }), _jsx("div", { className: "col-span-6 sm:col-span-3", children: _jsx("select", { value: selectedWebcam, onChange: (e) => setSelectWebcam(e.target.value), className: "mt-1 block w-full py-2 px-3 border border-gray-300 bg-transparent dark:border-darkText dark:text-darkText rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", children: devices }) }), _jsx("div", { className: "col-span-6 sm:col-span-3", children: _jsx(PreviewWebcam, { deviceId: selectedWebcam }) }), _jsx("div", { className: "py-3 bg-gray-50 dark:bg-transparent text-right", children: _jsx("button", { className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none", onClick: () => shareWebcam(), children: t('share') }) })] })] }) }) }));
    };
    return _jsx(_Fragment, { children: render() });
};
_react_refresh_temp_2 = ShareWebcamModal;
$RefreshReg$(_react_refresh_temp_2, "ShareWebcamModal");
_react_refresh_temp_3(ShareWebcamModal, "8Xx7wJCCwR7tsB9CVANzc9T7b5k=", false, () => [useAppSelector, useAppDispatch, useTranslation]);
export default ShareWebcamModal;
